import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as CoreFns from '../utilities/CoreFns';
import ElementCreator from './ElementCreator';


export function addRichText(objPath, organicChanges, currentList, refObject, userNos, userID, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, onClickItemChangeSelection, setIsShowingSomeDropDown){

  return function(e){
    var doInputActions = ResponsiveFns.doInputActionsFn(objPath, organicChanges, currentList, userID);

    function insertX(){


      var selection = document.getSelection();
      var upwardInfo = [];
      var internalVariables = {};

        var idOut;
        if (selection){
          
          var id = CoreFns.uuidCheckEverywhere(userNos, currentList);
          var itemLoc = ['as', id];

          var yHere = {n:'1', s:{text:ResponsiveFns.msg('Hello')}, oc:{}, t:'SPAN'};
          yHere._na = id.substr(id.length - 3);

          var changes2 = [{t:'w',w:itemLoc,n:yHere}];
          organicChanges(changes2);
          var ele = ElementCreator({t:'a',n:'SPAN',i:id}, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, upwardInfo, onClickItemChangeSelection, objPath, false, false);
          
          CoreFns.squeezeIn([ele], selection, objPath);
          var ref1 = refObject[objPath.join('_')];
          doInputActions(ref1);

          ele.onclick();
        }
        return idOut;

    }



    insertX();
    setIsShowingSomeDropDown(false);    

  }


  }
